import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import clsx from "clsx";
import React from "react";

export type ToastType = "success" | "error";

export type ToastProps = {
  type: ToastType;
  children: React.ReactNode;
  className?: string;
};

export const Toast: React.FC<ToastProps> = ({ type, children, className }) => {
  const Icon = type === "success" ? CheckCircleIcon : ExclamationCircleIcon;
  return (
    <div
      className={clsx(
        "flex w-full items-start gap-2 rounded-xl border border-secondary bg-primary p-4 shadow-lg",
        className,
      )}
    >
      <Icon
        className={clsx(
          "size-5 shrink-0",
          type === "success"
            ? "text-fg-success-primary"
            : "text-fg-error-primary",
        )}
      />
      <p className="flex-1 text-sm font-semibold text-primary">{children}</p>
    </div>
  );
};
